import {
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  SET_COUNTRY,
  SET_IS_ADVANCED,
  SET_SELECTED_USERS,
  SET_STOCKS,
  SET_STOCK_GROUP,
  SET_STRATEGIES
} from './actions';
import { Country, DataContextActionProps, DataState } from 'types/custom/data';

// initial state
export const initialState: DataState = {
  stocks: [],
  stockGroups: [],
  notifications: [],
  selectedUsers: [],
  strategies: [],
  isAdvanced: localStorage.getItem('advanced') ? true : false,
  country: (localStorage.getItem('country') ?? Country.in) as Country
};

// ==============================|| DATA REDUCER ||============================== //

const dataReducer = (state = initialState, action: DataContextActionProps): DataState => {
  switch (action.type) {
    case SET_STOCKS: {
      return { ...state, stocks: action.payload?.stocks! };
    }
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: action.payload?.notifications!
      };
    case REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter((notification) => notification.id !== action.payload)
      };
    case SET_SELECTED_USERS: {
      return {
        ...state,
        selectedUsers: action.payload?.selectedUsers!
      };
    }
    case SET_STOCK_GROUP: {
      return {
        ...state,
        stockGroups: action.payload?.stockGroups!
      };
    }
    case SET_STRATEGIES: {
      return {
        ...state,
        strategies: action.payload?.strategies!
      };
    }
    case SET_IS_ADVANCED: {
      return {
        ...state,
        isAdvanced: !action.payload?.advanced!
      };
    }
    case SET_COUNTRY: {
      return {
        ...state,
        country: action.payload?.country!
      };
    }

    default: {
      return state;
    }
  }
};

export default dataReducer;
